import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class kardexService {
    /******* QUERIES ******/

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/kardex/paginacion?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async establecimientoAlmacen(filter) {
        const response = await axios
            .get(`${ERP}logistica/kardex/formato-general/establecimiento-almacen?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async producto(filter) {
        const response = await axios
            .get(`${ERP}logistica/kardex/formato-general/producto?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async movimiento(filter) {
        const response = await axios
            .get(`${ERP}logistica/kardex/formato-general/movimiento?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelDetallado(filter) {
        const response = await axios
            .get(`${ERP}logistica/kardex/excel-detallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }; 
    
    async excelResumido(filter) {
        const response = await axios
            .get(`${ERP}logistica/kardex/excel-resumido?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };   
}

export default new kardexService();